import { motion } from 'framer-motion';
import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const PoliciesModalContent = styled(motion.div)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  background: #ffffff;
  border-radius: 12px;

  padding: 48px;
  overflow: hidden;

  ${BREAKPOINTS.mobile} {
    padding: 32px 24px;
  }
`;

export const PoliciesModalCloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 32px;
  height: 32px;
  padding: 0;

  background: transparent;
  border: none;
  border-radius: 50%;

  font-size: 20px;
  line-height: 1;
  color: #171c33;

  cursor: pointer;

  &:hover {
    background: rgba(31, 32, 37, 0.08);
  }
`;

export const PoliciesModalTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  color: #171c33;
  margin: 0 0 16px 0;
  text-align: center;
`;

export const PoliciesModalBody = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: rgba(31, 32, 37, 0.7);
  margin: 0 0 24px 0;
  text-align: center;
`;

export const PoliciesModalViewLink = styled.span`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #171c33;
  text-decoration: underline;
  margin-bottom: 32px;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`;

export const PoliciesModalTextContainer = styled(motion.div)`
  width: 100%;
  overflow: hidden;
`;

export const PoliciesModalTextContent = styled.div`
  width: 100%;
  max-height: 50vh;
  overflow-y: auto;

  padding: 24px;
  margin-bottom: 24px;

  background: #fafafa;
  border: 1px solid rgba(31, 32, 37, 0.1);
  border-radius: 8px;

  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: #171c33;

  h1 {
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    margin: 0 0 16px 0;
  }

  h2 {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    margin: 24px 0 12px 0;
  }

  p {
    margin: 0 0 12px 0;
  }

  b,
  strong {
    font-weight: 700;
  }

  ul {
    margin: 0 0 12px 0;
    padding-left: 24px;
  }

  li {
    margin-bottom: 6px;
  }
`;

export const PoliciesModalCheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;

  width: 100%;
  margin-bottom: 24px;

  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #171c33;

  cursor: pointer;
`;

export const PoliciesModalCheckbox = styled.input`
  width: 18px;
  height: 18px;
  flex-shrink: 0;

  accent-color: #171c33;
  cursor: pointer;
`;

interface PoliciesModalButtonProps {
  disabled?: boolean;
}

export const PoliciesModalButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  width: 100%;
`;

export const PoliciesModalButton = styled.button<PoliciesModalButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  padding: 14px 24px;

  background: #171c33;
  border: none;
  border-radius: 8px;

  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  color: #ffffff;

  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const PoliciesModalCancelButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  padding: 14px 24px;

  background: transparent;
  border: 1px solid rgba(31, 32, 37, 0.2);
  border-radius: 8px;

  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  color: #171c33;

  cursor: pointer;

  &:hover {
    background: rgba(31, 32, 37, 0.05);
  }
`;
